import { gql } from '@apollo/client'

export const Query = gql`
  query EditAssetCase($companyId: ID!, $filters: AssetCaseFilters) {
    assetCases(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        description
        height
        length
        warehouse {
          id
        }
        weight
        width
        barcode { 
          id
          barcode
        }
      }
    }
  }
`
